import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=3d15eb14&scoped=true"
import script from "./DynamicList.vue?vue&type=script&lang=js"
export * from "./DynamicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15eb14",
  null
  
)

export default component.exports